import { Injectable, inject } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { GridInput } from '@it2go/data-grid';
import { gql } from '@apollo/client/core';
import { map, Observable } from 'rxjs';
import { CreateUserInput, UserGridObject, UserObject } from '@it2go/types';
import { filterFrag } from './types/filter.types';
import { userGridItemFrag } from './types/user.types';

/**
 * @Deprecated()
 */
@Injectable()
export class UserService {
    private apollo = inject(Apollo);


    getUsers(input: GridInput | null) {
        return this.apollo.query<{ user: { filter: UserGridObject } }>({
            query: gql`
                query($input: GridInput) {
                    user {
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${userGridItemFrag}
                            }
                        }
                    }
                }
            `,
            variables: { input },
        })
        .pipe(map((result) => result.data!.user.filter));
    }

    createUser(input: CreateUserInput) {
        return this.apollo.mutate<{ user: { create: UserObject } }>({
            mutation: gql`
                mutation($input: CreateUserInput!) {
                    user {
                        create(input: $input) {
                            id
                            email
                            name
                            surname
                            titleBeforeName
                            titleAfterName
                        }
                    }
                }
            `,
            variables: { input },
        })
        .pipe(map((result) => result.data!.user.create));
    }

    sendPushNotification(props: any): Observable<boolean> {
        return this.apollo
            .mutate<{ ok: boolean }>({
                mutation: gql`
                    mutation ($id: String!, $user_id: String!) {
                        notifications {
                            create(
                                notification: {
                                    author_name: "Admin"
                                    id: $id
                                    is_read: false
                                    link: "/content/organizations/organization/1"
                                    notification_type: "812e6a36-90f1-4cf3-bf69-9cae87ca7f4a"
                                    picture_url: "http://placekitten.com/200/200"
                                    subtitle: "This is test notification"
                                    time: "${new Date().toISOString()}"
                                    title: "Test"
                                    user_id: $user_id
                                }
                            ) {
                                id
                            }
                        }
                    }
                `,
                variables: props,
            })
            .pipe(map((result) => result.data?.ok || false));
    }

}
